import { inject, observer } from "mobx-react";
import React from "react";
import { CardGrid, Card, SplitView, SplitRefType } from "src/views";
import { Item } from "src/models";
import { UserStore, SpaceStore, RoutingStore } from "src/stores";
import { ItemStore } from "src/stores/itemStore";
import { DataType, IItem, ItemType } from "src/types";
import { DelivBoard } from "./boards/delivBoard";
import { QuestionBoard } from "./boards/questionBoard";
import { PosFilter } from "./posFilter";
import styled from "styled-components";
export interface IItemViewProps {
  itemStores?:   {[type: string]: ItemStore<Item<IItem>, IItem>},
  routingStore?: RoutingStore,
  spaceStore?:   SpaceStore
  type:          ItemType,
  userStore?:    UserStore,
}

export const ItemView = inject("userStore", "itemStores", "spaceStore", "routingStore" )(observer((props: IItemViewProps): JSX.Element => {
  const {type, itemStores, routingStore } = props;

  const splitRef = React.useRef<SplitRefType>();
  
  const board = React.useMemo(() => {
    switch(type) {
      case DataType.Question:
        return <QuestionBoard />;
      case DataType.Deliverable:
        return <DelivBoard />;
      case DataType.Milestone:
        return <DelivBoard />;
      default:
        return null;
    }
  }, [type]);

  const itemType = type === DataType.Milestone ? DataType.Deliverable : type;

  return (
    <SplitView
      key       = {routingStore.boardDirection}
      offset    = {routingStore.navBarSize}
      direction = {routingStore.boardDirection}
      ref       = {splitRef}
      top       = {board}
      bottom    = {
        <>
          <PosFilter type={type} />
          <CardGridContainer>
            <CardGrid>
            {itemStores[itemType].getItems.map(i => (
              <Card key={i.id} data={i} onClick={() => itemStores[itemType].setActive(i)} type={itemType as DataType}/>
            ))}
            </CardGrid>
          </CardGridContainer>
        </>
      }
    />
  );
}));


const CardGridContainer = styled.div`
  padding: 1rem;
  margin:  0 2rem 0 2rem;
`